module.exports = __webpack_public_path__ + "static/media/iconLocation.25152a4a.svg";